// components/PrincipleInlineCard.tsx — ported from docs/superpowers/design-2026-04-21/messages.jsx

import type { JSX } from 'react';
import { useTokens } from '../state/theme';
import { ProfProse } from './ProfProse';

export interface Principle {
  id: string;
  argomentoName: string;
  nameIt: string;
  enunciato: string;
  regola?: string;
}

export interface PrincipleInlineCardProps {
  principle: Principle | null;
  onClose: () => void;
}

export function PrincipleInlineCard({ principle, onClose }: PrincipleInlineCardProps): JSX.Element | null {
  const t = useTokens();
  if (!principle) return null;
  return (
    <div
      className="asc-fade-in"
      role="region"
      aria-label={`Dettaglio principio ${principle.nameIt}`}
      style={{
        marginTop: 12, padding: 18,
        background: t.surface, border: `1px solid ${t.lineStrong}`,
        borderRadius: t.radius.lg, position: 'relative',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
          stroke={t.accent} strokeWidth="1.4" style={{ marginTop: 3 }}>
          <path d="M3 2h7a3 3 0 013 3v9H6a3 3 0 01-3-3V2z"/>
          <path d="M3 11a3 3 0 013-3h7"/>
        </svg>
        <div style={{ flex: 1 }}>
          <div style={{
            fontFamily: t.fonts.mono, fontSize: 9.5, letterSpacing: 0.6,
            color: t.textFaint, textTransform: 'uppercase',
          }}>Principio &middot; {principle.argomentoName}</div>
          <div style={{
            fontFamily: t.fonts.heading, fontSize: 18, fontWeight: 500,
            color: t.text, letterSpacing: -0.3, marginTop: 2, lineHeight: 1.25,
          }}>{principle.nameIt}</div>
        </div>
        <button
          onClick={onClose}
          aria-label="Chiudi"
          style={{
            background: 'transparent', border: 'none', cursor: 'pointer',
            color: t.textFaint, padding: 2,
          }}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
            stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
            <path d="M3 3l8 8M11 3l-8 8"/>
          </svg>
        </button>
      </div>

      <ProfProse text={principle.enunciato} serif size={14.5}/>

      {principle.regola && (
        <div style={{
          marginTop: 12, padding: '10px 12px',
          background: t.accentSoft, borderRadius: t.radius.md,
        }}>
          <div style={{
            fontFamily: t.fonts.mono, fontSize: 9.5, letterSpacing: 0.6,
            color: t.accent, textTransform: 'uppercase', marginBottom: 5,
          }}>Regola · la tecnica</div>
          <ProfProse text={principle.regola} serif={false} size={13.5}/>
        </div>
      )}
    </div>
  );
}
